import { FormWrapper } from "@/components/molecules/FormWrapper/FormWrapper";
import { FormSelect } from "@/components/molecules/FormSelect/FormSelect";
import { mapToFormValues } from "../infrastructure/InstrumentlMapper";
import { InstrumentFormProps } from "./InstrumentForm.types";
import { InstrumentFormData, schema } from "../infrastructure/InstrumentConstants";
import { useConfirmDialogs } from "@/core/context/DialogContext";
import { FormDateInput } from "@/components/molecules/FormDateInput/FormDateInput";
import { FormInput } from "@/components/molecules/FormInput";

export const InstrumentForm = ({
    formStatus,
    instrumentSelected,
    instrumentTypeOptions,
    onSubmit,
    onDelete,
}: InstrumentFormProps) => {
    const showDialog = useConfirmDialogs();

    const confirmDelete = async (id: string) => {
        const confirm = await showDialog({
            title: "¿Estás seguro?",
            description: "Esta acción eliminará el registro. ¿Deseas continuar?",
            variant: "delete",
        });

        if (confirm) {
            onDelete(id);
        }
    }

    return (
        <FormWrapper<InstrumentFormData>
            defaultValues={instrumentSelected ? mapToFormValues(instrumentSelected) : undefined}
            onSubmit={onSubmit}
            schema={schema}
            formStatus={formStatus}
            onDelete={confirmDelete}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <FormSelect name="instrumentType" label="Tipo de instrumento" options={instrumentTypeOptions} />
                <FormInput name="mnemonic" label="Nemotécnico" />
                <FormInput name="isin" label="ISIN" />
                <FormInput name="currency" label="Moneda" />
                <FormInput name="interestRate" label="Tasa facial" />
                <FormInput name="frequency" label="Periodicidad" />
                <FormDateInput
                    name="issuanceDate"
                    label="Fecha emisión"
                    fromYear={new Date().getFullYear() - 20}
                    toYear={new Date().getFullYear() + 20}
                />
                <FormDateInput
                    name="maturityDate"
                    label="Fecha vencimiento"
                    fromYear={new Date().getFullYear() - 20}
                    toYear={new Date().getFullYear() + 20}
                />
                <FormInput name="issuerName" label="Emisor" />
                <FormInput name="rating" label="Calificación" />
            </div>
        </FormWrapper>
    );
};
